module.exports = __webpack_public_path__ + "img/icon_e.df981c0b.png";